import { Component, OnInit, Input } from '@angular/core';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { CabiancaChart } from 'src/app/models/cabiancaChart.model';

@Component({
  selector: 'cabianca-chart',
  templateUrl: './cabianca-chart.component.html',
  styleUrls: ['./cabianca-chart.component.css']
})
export class CabiancaChartComponent implements OnInit {

  @Input() chart: CabiancaChart
  @Input() typeName: string
  public isAdmin: boolean

  constructor(private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.isAdmin = this.authenticationService.isImpersonatedButAdmin()  
    }  
  }

